// extracted by mini-css-extract-plugin
export default {"flex":"YW","imgwrap":"ZW","image":"aX","textinfo":"bX","producttitle":"cX","bolder":"eX","block":"fX","info":"gX","moredetails":"hX","whitebox":"iX","old_price":"jX","discount":"kX"};
    if(module.hot) {
      // 1721922366730
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  